import type { StripeElementsOptions } from "@stripe/stripe-js";

// Default Config for stripe elements
export const commonElementAppearance: StripeElementsOptions["appearance"] = {
  theme: undefined,
  rules: {
    ".Label": {
      padding: "2px 0px",
      marginBottom: "3px",
      fontSize: "14px",
      fontWeight: "500",
      color: "rgb(0 75 44)",
    },
    ".Input": {
      borderRadius: "8px",
      backgroundColor: "#ffffff",
      padding: "11px 12px",
      fontSize: "14px",
      fontWeight: "500",
      color: "rgb(0, 75, 44)",
      border: "none",
    },
    ".Input::placeholder": {
      color: "rgba(0, 75, 44, 0.5)",
    },
    ".Error": {
      marginTop: "5px",
      fontWeight: "500",
      fontSize: "0.875rem",
      fontFamily: "agenda, Roboto, \"Helvetica Neue\", sans-serif",
    },
    ".Tab:hover, .Tab--selected": {
      backgroundColor: "#E7F2ED",
    },
    ".TermsText": {
      fontSize: "13px",
      fontWeight: "500",
      color: "rgb(0 75 44)",
    },
  },
};

export const paymentStripeElementsAppearance: StripeElementsOptions["appearance"] =
  {
    ...commonElementAppearance,
    rules: {
      ...commonElementAppearance.rules,
    },
    variables: {
      colorPrimary: "#004b2c",
      colorBackground: "transparent",
      colorText: "#004b2c",
      colorBackgroundText: "black",
      colorDanger: "#df1b41",

      fontFamily: "agenda, Roboto, \"Helvetica Neue\", sans-serif",
      fontWeightNormal: "500",

      spacingUnit: "2px",
      spacingGridRow: "9px",
      spacingGridColumn: "7.5px",

      borderRadius: "8px",

      focusBoxShadow: "none",
      focusOutline: "#004b2c",
    },
  };
